import BaseModelAPI from '../BaseModelAPI';

export default class ReportRekapDeliveryList extends BaseModelAPI {

	static entity = 'newreport1996list'
	static entityName = 'reportrekapdelivery';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
